import React from 'react';
import ManageAd from './manageAd';
import CreateDate from './createdDate';
interface CardStatusProps {
  status: 'published' | 'rejected' | 'pending';
  createdDate: string;
  app: 'farm' | 'wholesaler';
  guid: string;
  type: 'wanted-post';

  refetch: () => void;
}
const CardStatus = ({
  status,
  createdDate,
  app,
  guid,
  type,
  refetch,
}: CardStatusProps) => {
  return (
    <div className="flex w-full justify-between">
      <CreateDate status={status} createdDate={createdDate} />
      <ManageAd
        type={type}
        app={app}
        guid={guid}
        status={status}
        refetch={refetch}
      />
    </div>
  );
};

export default CardStatus;
